"use client"

import Image from "next/image"
import { memo, useEffect, useState } from "react"
import { resolveImageUrl } from "@/lib/mediaUrl"

export const FALLBACK_IMAGE = "/no-image.png"

/**
 * Public news images — missing/broken src always shows branded placeholder.
 */
const CustomImage = ({
    src,
    alt = "Prajavarta News",
    width = 600,
    height = 400,
    className = "",
    style = {},
    priority = false,
    folder = "news",
    crop = "fill",
    gravity = "auto",
    objectFit = "cover",
    sizes,
    ...props
}) => {
    const resolvedSrc = resolveImageUrl(src, folder, {
        width: typeof width === "number" ? width : undefined,
        height: typeof height === "number" ? height : undefined,
        crop,
        gravity,
    })

    const [displaySrc, setDisplaySrc] = useState(resolvedSrc || FALLBACK_IMAGE)

    useEffect(() => {
        setDisplaySrc(resolvedSrc || FALLBACK_IMAGE)
    }, [resolvedSrc])

    const isFallback = displaySrc === FALLBACK_IMAGE

    return (
        <Image
            src={displaySrc}
            alt={alt || "Prajavarta News"}
            width={width}
            height={height}
            className={className}
            style={{
                objectFit,
                ...style,
            }}
            priority={priority}
            sizes={sizes || "(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 600px"}
            quality={75}
            // Local public fallback — skip optimizer so missing featured images always render
            unoptimized={isFallback}
            {...props}
            onError={() => {
                if (!isFallback) {
                    setDisplaySrc(FALLBACK_IMAGE)
                }
            }}
        />
    )
}

export default memo(CustomImage)
